angular.module('dpw.directives').directive('dpwSetUpApp', [function () {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'dpw-set-up-app.directive.html',
        controllerAs: 'ctrl',
        controller: ['$scope', 'setUpAppService', 'dpwToastService',
            function ($scope, setUpAppService, dpwToastService) {
                var self = this;

                self.$onInit = function () {
                    self.app = $scope.config.app;
                    self.conversationName = $scope.config.conversationName;

                    self.resolveAppAttributes();
                    self.resolveWebhookUrl();
                    self.resolveSetupMode();
                };

                self.resolveAppAttributes = function () {
                    var appAttributes = _.get($scope, 'config.app.attributes');

                    self.iframeEnabled = _.get(_.find(appAttributes, {id: 'GlipIframeEnabled'}), 'value') === 'true';
                    self.iframeUrl = _.get(_.find(appAttributes, {id: 'GlipIframeUrl'}), 'value');
                    self.instructionUrl = _.get(_.find(appAttributes, {id: 'GlipInstructionUrl'}), 'value');

                    self.isAutomaticSetupSupported = Boolean(self.iframeEnabled && self.iframeUrl);
                };
                
                self.resolveWebhookUrl = function () {
                    setUpAppService.installMna($scope.config.app.id, $scope.config.groupId)
                        .then(function (response) {
                            self.webhookUrl = response.webhookUrl;
                            self.integrationId = response.integrationId;
                        });
                };

                self.resolveSetupMode = function () {
                    self.isAutomaticSetup = self.isAutomaticSetupSupported;
                };

                self.onToggleMode = function () {
                    self.isAutomaticSetup = !self.isAutomaticSetup;
                };

                self.onCancel = function () {
                    $scope.config.onClose();
                    
                    if (self.integrationId) {
                        setUpAppService.uninstallMna($scope.config.app.id, self.integrationId);
                    }
                };

                self.onFinish = function () {
                    $scope.config.onClose();

                    dpwToastService.showToast('The app has been installed successfully!', {
                        extraClass: 'dpw-set-up-app-toast-container',
                        showCloseBtn: true,
                        disappearTime: 2000
                    });
                };
        }]
    };
}]);
